/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Component, ChangeDetectionStrategy} from '@angular/core';
import {PeriodsViewsService} from '../services/periods-views/periods-views.service';
import {SettlementDetailModel} from '../models/settlement/settlement-detail/settlement-detail.model';
import {PeriodTypeInfoChartModel} from '../models/period-type-info-chart/period-type-info-chart.model';
import {CurrencyBaseModel} from '../models/currency/currency-base.model';

@Component({
    selector: 'app-settlements-view',
    templateUrl: './settlements-view.component.html',
    styleUrls: ['./settlements-view.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SettlementsViewComponent {

    get getCurrency(): CurrencyBaseModel {
        return this.settlementsList?.find((value) => value != null)?.currency;
    }

    get settlementsListTitle(): string {
        const size = this.settlementsList?.length ?? 0;
        return `SETTLEMENTS LIST (${size})`;
    }

    get settlementsList(): SettlementDetailModel[] {
        return this.periodsViewsService.getSettlementsList();
    }

    get periodTypeInfoChartData(): Map<string, PeriodTypeInfoChartModel> {
        return this.periodsViewsService.getPeriodTypeInfoChartData();
    }

    constructor(private periodsViewsService: PeriodsViewsService) {
    }
}
